import { getArtifactVersion, getFullArtifactId } from '../utils';
export var createPanoramaClient = function (essentials, options) {
    if (!essentials.createPanoramaClient) {
        return null;
    }
    var componentId = options.componentId, sentryConfig = options.sentryConfig, environment = options.environment;
    return essentials.createPanoramaClient({
        fullArtifactId: getFullArtifactId(),
        artifactVersion: getArtifactVersion(),
        componentId: componentId,
        sentryDsn: sentryConfig === null || sentryConfig === void 0 ? void 0 : sentryConfig.DSN,
        sentryEnvironment: environment,
    });
};
//# sourceMappingURL=createPanoramaClient.js.map